export enum ImageScaleType {
  SCALE = "Scale",
  FIXED = "Exact Size",
  NONE = "No Change",
}

export default ImageScaleType;
